<template>
  <div class="fromPage" v-if="!showLoad">
    <div class="mc" v-if="mcShowPicker"></div>
    <p v-if="endShow" class="endTiemPicker">
      距离结束时间还有：
      <van-count-down
        @finish="changeTextType"
        :time="endedTime"
        format="DD 天 HH 时 mm 分 ss 秒"
      />
    </p>
    <div class="header">
      <h4>{{ baseData.title }}</h4>
      <p class="intro">{{ baseData.intro }}</p>
    </div>
    <ol class="olStyle">
      <li
        class="fromList clearfix"
        v-for="(item, index) in baseData.componentResultList"
        :key="index"
      >
        <span class="fl olNumber">{{ index + 1 }}.</span>
        <!-- 输入框类型 -->
        <div class="listInfo fl" v-if="item.type == 'sr'">
          <van-cell-group class="baseNone baseSr">
            <van-cell :title="`${item.title}`" readonly class="baseQ" />
            <van-field
              v-model="item.answerValue"
              placeholder="请填写..."
              rows="1"
              autosize
              :readonly="!editType"
              type="textarea"
              class="baseA baseSrA"
            />
          </van-cell-group>
          <div
            class="right"
            v-if="status == 'finish' && item.rightValue != null"
          >
            <p>答案：</p>
            <ul>
              <li>{{ item.rightValue }}</li>
            </ul>
          </div>
        </div>
        <!-- 打分 -->
        <div class="listInfo fl" v-if="item.type == 'df'">
          <van-cell-group class="baseNone baseSr">
            <van-cell :title="`${item.title}`" readonly class="baseQ" />
            <van-rate
              void-icon="star"
              void-color="#eee"
              v-model="item.answerValue"
              class="vanRate"
              :readonly="!editType"
            />
          </van-cell-group>
        </div>
        <!-- 附件类型 -->
        <div class="listInfo fl filesBox" v-if="item.type == 'fj'">
          <a
            href="javascript:void(0);"
            class="recordImg"
            v-if="editType"
            @click="uploadFile(item, index)"
            >上传附件</a
          >
          <van-cell-group class="baseNone baseSr">
            <van-cell :title="`${item.title}`" readonly class="baseQ" />
            <!-- 附件组件 -->
            <van-cell-group class="baseNone baseSalary accessoryBox">
              <div class="detailMian" v-if="item.flies.length > 0">
                <ul>
                  <li
                    class="clearfix"
                    v-for="(itemFj, Itemindex) in baseData.componentResultList[
                      index
                    ].flies"
                    :key="Itemindex"
                  >
                    <dl class="fl">
                      <dt @click="Showswiper(item.flies, Itemindex)">
                        <img
                          :src="
                            getFormat(itemFj) == 'jpg' ||
                            getFormat(itemFj) == 'png' ||
                            getFormat(itemFj) == 'jpeg'
                              ? itemFj
                              : getFormat(itemFj) == 'pdf'
                              ? '' + baseUrl + 'searchImg/pdf.png'
                              : getFormat(itemFj) == 'xlsx' ||
                                getFormat(itemFj) == 'xls'
                              ? '' + baseUrl + 'searchImg/excel.png'
                              : '' + baseUrl + 'searchImg/word.png'
                          "
                          alt
                        />
                      </dt>
                    </dl>
                    <a
                      href="javascript:void(0);"
                      class="downloadBtn fr"
                      v-if="!editType"
                      @click="downLoad(itemFj)"
                      >下载</a
                    >
                    <a
                      href="javascript:void(0);"
                      class="downloadBtn delBtn fr"
                      v-if="editType"
                      @click="delFile(item, index, Itemindex)"
                      >删除</a
                    >
                  </li>
                </ul>
              </div>
              <p
                v-if="
                  !editType && item.flies.length == '0' && status == 'finish'
                "
                class="noneFile"
              >
                无数据
              </p>
            </van-cell-group>
          </van-cell-group>
        </div>
        <div class="listInfo fl" v-if="item.type == 'xz'">
          <!-- 多选 -->
          <div class="slectCheckbox" v-if="item.multiSelect == true">
            <div class="selectType" v-if="item.selectType == 'select'">
              <van-cell :title="`${item.title}`" readonly class="baseQ" />
              <van-field
                v-model="item.answerValueName"
                type="textarea"
                placeholder="点击选择"
                @click="checkSelectMoreTypePicker(item, index)"
                readonly
                rows="1"
                autosize
                :class="[
                  'zcSelectType',
                  item.answerValueName == '' ? '' : 'changeStyle',
                ]"
                :is-link="editType"
              />
              <div
                class="right"
                v-if="status == 'finish' && item.rightValue != null"
              >
                <p>答案：</p>
                <ul>
                  <li>{{ item.rightValue }}</li>
                </ul>
              </div>
            </div>
            <div class="checkType" v-if="item.selectType == 'check'">
              <van-cell :title="`${item.title}`" readonly class="baseQ" />
              <van-checkbox-group v-model="item.otherTypeValueNames">
                <van-cell-group>
                  <van-cell
                    v-for="(
                      seletItem, seletItemIndex
                    ) in item.selectItemResultsList"
                    clickable
                    :key="seletItem.id"
                    :title="`${seletItem.title}`"
                    @click="
                      changOtherTypeValue(
                        seletItemIndex,
                        item,
                        seletItem,
                        index
                      )
                    "
                    :class="[
                      seletItem.checkedType == true ? 'changeStyle' : '',
                    ]"
                  >
                    <template #right-icon>
                      <van-checkbox
                        :name="seletItem.title"
                        ref="changeCheckboxes"
                        shape="square"
                      />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-checkbox-group>
              <div
                class="right"
                v-if="status == 'finish' && item.rightValue != null"
              >
                <p>答案：</p>
                <ul>
                  <li>{{ item.rightValue }}</li>
                </ul>
              </div>
            </div>
            <div class="ballotType" v-if="item.selectType == 'ballot'">
              <van-cell :title="`${item.title}`" readonly class="baseQ" />
              <van-checkbox-group
                v-model="item.otherTypeValueNames"
                v-if="editType && status != 'finish' && status != 'ended'"
              >
                <van-cell-group>
                  <van-cell
                    v-for="(
                      ballotItem, ballotItemIndex
                    ) in item.selectItemResultsList"
                    clickable
                    :key="ballotItem.id"
                    :title="`${ballotItem.title}`"
                    @click="
                      changOtherTypeValue(
                        ballotItemIndex,
                        item,
                        ballotItem,
                        index
                      )
                    "
                    :class="[
                      ballotItem.checkedType == true ? 'changeStyle' : '',
                    ]"
                  >
                    <template #right-icon>
                      <van-checkbox
                        :name="ballotItem.title"
                        ref="checkBallotboxes"
                        shape="square"
                      />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-checkbox-group>
              <!-- 查看详情时 -->
              <div
                class="ballotListBox"
                v-if="status == 'finish' || status == 'ended'"
              >
                <ul>
                  <li
                    class="ballotList"
                    v-for="(ballotItem, ballotItemIndex) in item.BallotListData"
                    :key="ballotItemIndex"
                  >
                    <van-cell-group>
                      <p class="ballotDetailTit">
                        <van-tag
                          v-if="ballotItem.isselect"
                          color="#FC8F0C"
                          type="danger"
                          >已选</van-tag
                        >
                        {{ ballotItem.title }}
                      </p>
                      <p class="ballotPercentage">
                        <van-progress
                          :show-pivot="false"
                          :percentage="
                            getchangePercentage(ballotItem.usernum, index)
                          "
                        />
                        <span class="description"
                          >{{ ballotItem.usernum }}票
                          {{
                            getchangePercentage(ballotItem.usernum, index)
                          }}%</span
                        >
                      </p>
                    </van-cell-group>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 单选 -->
          <div class="radioCheckBox" v-else>
            <div class="RadioCheckType" v-if="item.selectType == 'check'">
              <!--展开类型 -->
              <van-cell :title="`${item.title}`" readonly class="baseQ" />
              <van-radio-group v-model="RadioCheckValueName">
                <van-cell-group>
                  <van-cell
                    v-for="(
                      radioItem, radioItemIndex
                    ) in item.selectItemResultsList"
                    :readonly="!editType"
                    :key="radioItem.id"
                    :title="`${radioItem.title}`"
                    @click="
                      changeRadioCheckValue(index, radioItemIndex, radioItem)
                    "
                    :class="[
                      'baseA',
                      radioItem.checkedType == true ? 'changeStyle' : '',
                    ]"
                  >
                    <template #right-icon>
                      <van-radio :name="`${radioItem.title}`" />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>
              <div
                class="answerRight"
                v-if="status == 'finish' && item.rightValue != null"
              >
                <p>答案：</p>
                <ul>
                  <li>{{ item.rightValue }}</li>
                </ul>
              </div>
            </div>
            <div class="RadioSelectType" v-if="item.selectType == 'select'">
              <!--下拉类型 -->
              <van-cell :title="`${item.title}`" readonly class="baseQ" />
              <van-field
                readonly
                type="textarea"
                rows="1"
                autosize
                :class="[
                  'zcSelectType',
                  item.answerValueName == '' ? '' : 'changeStyle',
                ]"
                :is-link="editType"
                v-model="item.answerValueName"
                placeholder="点击选择"
                @click="checkShowRadioSeleType(item, index)"
              />
              <div
                class="right"
                v-if="status == 'finish' && item.rightValue != null"
              >
                <p>答案：</p>
                <ul>
                  <li>{{ item.rightValue }}</li>
                </ul>
              </div>
            </div>
            <div class="RadioBallotType" v-if="item.selectType == 'ballot'">
              <!--投票类型 -->

              <van-cell :title="`${item.title}`" readonly class="baseQ" />
              <van-radio-group
                v-model="RadioCheckValueName"
                v-if="editType && status != 'finish' && status != 'ended'"
              >
                <van-cell-group>
                  <van-cell
                    v-for="(
                      radioItem, radioItemIndex
                    ) in item.selectItemResultsList"
                    :readonly="!editType"
                    :key="radioItem.id"
                    :title="`${radioItem.title}`"
                    @click="
                      changeRadioCheckValue(index, radioItemIndex, radioItem)
                    "
                    :class="[
                      'baseA',
                      radioItem.checkedType == true ? 'changeStyle' : '',
                    ]"
                  >
                    <template #right-icon>
                      <van-radio :name="`${radioItem.title}`" />
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-radio-group>

              <!-- 查看详情时 -->
              <div
                class="ballotListBox"
                v-if="status == 'finish' || status == 'ended'"
              >
                <ul>
                  <li
                    class="ballotList"
                    v-for="(ballotItem, ballotItemIndex) in item.BallotListData"
                    :key="ballotItemIndex"
                    @click="jumpBallotListUrl(ballotItem)"
                  >
                    <van-cell-group>
                      <p class="ballotDetailTit">
                        <van-tag
                          v-if="ballotItem.isselect"
                          color="#FC8F0C"
                          type="danger"
                          >已选</van-tag
                        >
                        {{ ballotItem.title }}
                      </p>
                      <p class="ballotPercentage">
                        <van-progress
                          :show-pivot="false"
                          :percentage="
                            getchangePercentage(ballotItem.usernum, index)
                          "
                        />
                        <span class="description">
                          {{ ballotItem.usernum }}票
                          <span v-if="ballotItem.usernum != '0'"
                            >{{
                              getchangePercentage(ballotItem.usernum, index)
                            }}%</span
                          >
                        </span>
                      </p>
                    </van-cell-group>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ol>
    <div class="btnBox" v-if="editType">
      <van-button
        type="info"
        :loading="btnLoading"
        loading-text="保存中..."
        @click="saveAwser"
        class="btn"
        >提交</van-button
      >
    </div>

    <!-- 问卷调查优化  多选类型下的下拉选择 -->
    <van-popup
      v-model="selectMoreTypePicker"
      class="guardBox"
      @opened="changeGuarddata"
      @close="closeDataItemListPicker"
      position="bottom"
    >
      <div class="roleHeader clearfix">
        <a
          href="javascript:void(0);"
          class="fl"
          @click="closeDataItemListPicker"
          >取消</a
        >
        请选择
        <a href="javascript:void(0);" class="fr" @click="saveDataItemList"
          >确认</a
        >
      </div>
      <van-checkbox-group v-model="protectionResult" class="roleMain">
        <van-cell-group>
          <van-cell
            v-for="(item, itemIndex) in protectionData"
            :key="itemIndex"
            :title="`${item.title}`"
            @click="changeSelectTypeValue(itemIndex, item)"
          >
            <van-checkbox
              :name="item.title"
              ref="slectTypeCheckboxes"
              slot="right-icon"
              shape="square"
            />
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </van-popup>
    <!-- 弹出层：单选弹框-->
    <van-popup
      v-model="showRadioSeleType"
      @close="closeRadioSeleType"
      class="guardBox"
      position="bottom"
    >
      <div class="roleHeader clearfix">
        <a href="javascript:void(0);" class="fl" @click="closeRadioSeleType"
          >取消</a
        >
        请选择
        <a href="javascript:void(0);" class="fr" @click="saveRadioSeleType"
          >确认</a
        >
      </div>
      <van-radio-group v-model="radioSelectValueName" class="roleMain">
        <van-cell-group>
          <van-cell
            v-for="(childItem, itemIndex) in radioSelectData"
            :title="`${childItem.title}`"
            :key="itemIndex"
            @click="CheckRadio(itemIndex, childItem)"
          >
            <template #right-icon>
              <van-radio :name="`${childItem.title}`" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-popup>
    <!-- 弹框是否查看问卷调查 -->
    <van-dialog
      v-model="showViewQuestionPicker"
      title="提示"
      show-cancel-button
      @confirm="showViewQuestion"
      @cancel="cancelPicker"
      class="showShareBtnBox"
    >
      <p>您已经提交过问卷！是否继续查看问卷？</p>
    </van-dialog>
    <!-- 尚未开始/已开始需要答题，倒计时开始 -->
    <van-dialog
      v-model="showViewbeginTime"
      :title="activityTimeTit"
      show-cancel-button
      @confirm="judgeAnswer"
      @cancel="cancelPicker"
      :confirmButtonText="confirmButtonText"
      cancelButtonText="关闭"
      cancelButtonColor="red"
      class="CountDownPicker"
    >
      <p v-if="beginShow">
        距离开始时间还有：
        <van-count-down
          @finish="changeTextType"
          :time="beginTime"
          format="DD 天 HH 时 mm 分 ss 秒"
        />
      </p>
      <p v-if="status == 'pending'">活动已开始，是否进行答题</p>
      <p v-if="status == 'ended'">活动已结束，是否查看问卷</p>
    </van-dialog>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
import { getDeviceType, closePage } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "activityForm",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      applyData: {
        id: "",
        orgId: "",
        uid: "",
      },
      anwserId: "",
      itemMain: "",
      itemMainIndex: "",
      baseData: {}, // 问题详情
      title: "", //标题
      editType: false, //默认不可点击
      showTextType: false, //显示文字
      showBtn: false,

      showShare: false, //分享显示
      roleType: "",
      showShareBtn: false,
      showViewQuestionPicker: false,
      RateValue: 0, //评分

      answerIndexResult: [], //回答的问题id,
      btnLoading: false,
      mcShowPicker: false, //蒙层是否显示， 查看问卷权限
      timeNow: new Date(), //当前时间
      status: "isStart", //活动状态，pending进行中，ended结束，isStart未开始,start开始,finish已参与过活动
      showViewbeginTime: false, //活动尚未开始，倒计时弹窗
      beginShow: false, //活动开始时间倒计时
      activityTimeTit: "", //活动尚未开始/已经开始的提示标题
      beginTime: "", //活动开始时间
      confirmButtonText: "", //活动倒计时按钮文案
      endShow: false, //可以答题，距离结束时间
      endTime: "", //活动开始时间
      //问卷样式调整：
      //多选下拉类型
      selectIndex: "", //试卷当前题目的index
      selectMoreTypePicker: false,
      protectionResult: [], //多选状态下回调选中的值
      protectionData: [],
      protectionDataItemList: [], //多选状态下拉类型当前选中的值
      protectionOtherList: [], //多选状态展开，展开,投票类型当前选中的值
      double: "", //多选状态展开，展开,投票类型当前选中childIndex的值

      //单选下拉
      showRadioSeleType: false,
      radioSelectData: [], //单选下拉类型选项集合
      radioSelectValueName: "", //单选下拉类型回调选中的值
      radioSelectValue: "", //单选下拉类型选中的值
      RadioCheckValueName: "", //单选展开类型
      //投票类型查看
      BallotListData: [], //多选的投票类型查看
      clientType: getDeviceType(), //手机类型
    };
  },

  mounted() {
    window.setFile = this.setFiles; //app返回附件回调
    window.editPage = this.editPage; //编辑页面
    this.applyData.id = this.$route.query.commonId; //活动Id
    this.applyData.orgId = this.$route.query.orgId; //机构Id
    this.roleType = this.$route.query.commonType || "";
    this.$nextTick(() => {
      if (this.userinfo && this.userinfo.id) {
        this.timeNow = new Date();
        this.setShowLoad(false); //加载状态，默认为true加载
        this.applyData.uid = this.userinfo.id;
        this.initPage();
      }
    });
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    changeRate(item) {
      //打分赋值
      if (this.editType) {
        console.log(item.answerValue, "answerValue");
      }
    },
    //获取文件后缀名
    getFormat(name) {
      //获取文件后缀
      const _index = name.lastIndexOf(".");
      return _index >= 0 ? name.substring(_index + 1, name.length) : "";
    },

    initPage() {
      let _this = this;
      _this.$api.activity.player
        .activityDetails(_this.applyData)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            this.setShowLoad(false);
            _this.baseData = res.data;
            for (
              let i = 0;
              i < _this.baseData.componentResultList.length;
              i++
            ) {
              if (_this.baseData.componentResultList[i].type == "sr") {
                if (_this.baseData.componentResultList[i].answerValue == null) {
                  _this.baseData.componentResultList[i].answerValue = "";
                }
              }
              if (_this.baseData.componentResultList[i].type == "fj") {
                _this.baseData.componentResultList[i].flies = new Array();
                if (_this.baseData.componentResultList[i].answerValue != null) {
                  _this.baseData.componentResultList[i].flies =
                    _this.baseData.componentResultList[i].answerValue.split(
                      ","
                    );
                }
              }
              if (_this.baseData.componentResultList[i].type == "df") {
                _this.baseData.componentResultList[i].answerValue =
                  _this.baseData.componentResultList[i].answerValue == null ||
                  _this.baseData.componentResultList[i].answerValue == "null"
                    ? 0
                    : Number(_this.baseData.componentResultList[i].answerValue);
              }
              if (_this.baseData.componentResultList[i].type == "xz") {
                _this.baseData.componentResultList[
                  i
                ].selectItemResultsList.forEach((item) => {
                  _this.$set(item, "checkedType", false);
                });
                if (!_this.baseData.componentResultList[i].multiSelect) {
                  let dataArr =
                    _this.baseData.componentResultList[i].selectItemResultsList;
                  let valueArr =
                    _this.baseData.componentResultList[i].answerValue;
                  let namesString = "";

                  for (let j = 0; j < dataArr.length; j++) {
                    if (valueArr == dataArr[j].id) {
                      namesString = dataArr[j].title;
                      dataArr[j].checkedType = true;
                    }
                  }

                  //单选拉下类型的值
                  if (
                    _this.baseData.componentResultList[i].selectType == "select"
                  ) {
                    //单选状态的下拉类型
                    _this.$set(
                      _this.baseData.componentResultList[i],
                      "answerValueName",
                      ""
                    );

                    if (
                      _this.baseData.componentResultList[i].answerValue != null
                    ) {
                      //单选下拉类型
                      _this.$set(
                        _this.baseData.componentResultList[i],
                        "answerValueName",
                        namesString
                      );
                    }
                  }
                }

                if (_this.baseData.componentResultList[i].multiSelect) {
                  //多选状态
                  if (
                    _this.baseData.componentResultList[i].selectType == "select"
                  ) {
                    //多选状态的下拉类型
                    _this.$set(
                      _this.baseData.componentResultList[i],
                      "answerValueName",
                      ""
                    );
                  }
                  //多选状态的展开和投票类型
                  _this.$set(
                    _this.baseData.componentResultList[i],
                    "otherTypeValueNames",
                    []
                  );

                  if (
                    _this.baseData.componentResultList[i].answerValue == null ||
                    _this.baseData.componentResultList[i].answerValue == "null"
                  ) {
                    _this.baseData.componentResultList[i].answerValue = [];
                  } else {
                    let dataArr =
                      _this.baseData.componentResultList[i]
                        .selectItemResultsList;
                    let valueArr =
                      _this.baseData.componentResultList[i].answerValue.split(
                        ","
                      );
                    let namesArr = [];
                    for (let i = 0; i < valueArr.length; i++) {
                      //查看状态下获取选中的值
                      for (let j = 0; j < dataArr.length; j++) {
                        if (valueArr[i] == dataArr[j].id) {
                          namesArr.push(dataArr[j].title);
                          dataArr[j].checkedType = true;
                        }
                      }
                    }
                    _this.baseData.componentResultList[i].answerValue =
                      _this.baseData.componentResultList[i].answerValue.split(
                        ","
                      );
                    if (
                      _this.baseData.componentResultList[i].selectType ==
                      "select"
                    ) {
                      //多选下拉类型
                      _this.$set(
                        _this.baseData.componentResultList[i],
                        "answerValueName",
                        namesArr.join(",")
                      );
                    } else {
                      //多选展开类型
                      _this.$set(
                        _this.baseData.componentResultList[i],
                        "otherTypeValueNames",
                        namesArr
                      );
                    }
                  }
                }
                if (
                  _this.baseData.componentResultList[i].selectType == "ballot"
                ) {
                  _this.$set(
                    _this.baseData.componentResultList[i],
                    "BallotListData",
                    []
                  );
                  _this.$set(
                    _this.baseData.componentResultList[i],
                    "BallotListTatol",
                    ""
                  );
                }
              }
            }
            document.title =
              _this.baseData.title + _this.baseData.type == "qa"
                ? "问卷"
                : "测试";
            // 判断活动状态
            _this.baseData.endTime &&
            new Date(_this.baseData.endTime) - _this.timeNow < 0
              ? (_this.status = "ended")
              : _this.baseData.startTime &&
                new Date(_this.baseData.startTime) - _this.timeNow > 0
              ? (_this.status = "isStart")
              : (_this.status = "pending");

            console.log("status====" + _this.status);
            // 活动结束不能编辑
            _this.status == "ended" ? (_this.isEdit = false) : "";
            _this.startTime = _this.baseData.startTime
              ? +new Date(_this.baseData.startTime)
              : "";
            _this.endTime = _this.baseData.endTime
              ? +new Date(_this.baseData.endTime)
              : "";

            if (_this.status == "isStart") {
              _this.showViewbeginTime = true;
              _this.activityTimeTit = "活动尚未开始";
              _this.confirmButtonText = "查看问卷";
              let NewTime = new Date().getTime();
              let startDate = _this.baseData.startTime.replace(
                new RegExp("-", "gm"),
                "/"
              );
              _this.beginTime = new Date(startDate).getTime() - NewTime; //得到毫秒数
              _this.beginShow = true; //显示开始倒计时
            } else if (_this.status == "pending") {
              //活动已开始
              _this.addActivityAnswer();
              // _this.showViewbeginTime = true;
              // _this.activityTimeTit = "活动开始";
              // _this.confirmButtonText = "开始答题";
            } else if (_this.status == "ended") {
              //活动已结束
              _this.showViewbeginTime = true;
              _this.activityTimeTit = "活动已结束";
              _this.confirmButtonText = "查看问卷";
            }
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          _this.$toast("网络失败，请稍后重试");
        });
    },
    judgeAnswer() {
      //判断是否可以答题，未开始时， 是否可以查看题目
      let _this = this;
      if (_this.status == "isStart") {
        if (_this.baseData.isPreview) {
          _this.showViewbeginTime = false;
        } else {
          _this.$toast("活动尚未开始，不能查看");
          _this.mcShowPicker = true;
        }
      } else {
        this.addActivityAnswer(); //获取状态
      }
    },
    changeTextType() {
      //倒计时结束时
      let _this = this;
      _this.status == "pending";
      _this.beginShow = false; //显示开始倒计时
      _this.activityTimeTit = "活动开始";
      _this.confirmButtonText = "开始答题";
    },
    cancelPicker() {
      //关闭页面
      let text = " ";
      closePage(text);
    },
    addActivityAnswer() {
      //是否有权限编辑或新增
      let _this = this;
      let data = {
        activityId: _this.applyData.id,
        openId: "",
        uid: _this.applyData.uid,
      };
      _this.$api.activity.player
        .addActivityAnswer(data)
        .then((res) => {
          if (res.code == "1") {
            _this.anwserId = res.data.id;
            if (
              res.data == null ||
              res.data.status == "answerding" ||
              res.data.status == "quit"
            ) {
              //活动已经开始，并且之前没有提交过
              let NewTime = new Date().getTime();
              if (_this.baseData.endTime) {
                let startDate = _this.baseData.endTime.replace(
                  new RegExp("-", "gm"),
                  "/"
                );
                _this.endedTime = new Date(startDate).getTime() - NewTime; //得到毫秒数
                _this.endShow = true;
              }
              this.editType = true; //题目可编辑
            } else {
              //活动已经开始，并且之前已经提交过
              _this.status = res.data.status;
              _this.showViewQuestionPicker = true;
              _this.getActivityBallotStatistics();
            }
          } else {
            console.log("11212121");
            _this.getActivityBallotStatistics();
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          _this.$toast("网络失败，请稍后重试");
        });
    },
    //投票类型下查看详情时：
    getActivityBallotStatistics() {
      this.baseData.componentResultList.forEach((item, index) => {
        if (item.selectType == "ballot") {
          this.renderBallot(item.id, index);
        }
      });
    },
    renderBallot(id, parentIndex) {
      let _this = this;
      _this.$api.activity.player
        .activityBallotStatistics(id)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            this.$set(
              this.baseData.componentResultList[parentIndex],
              "BallotListData",
              JSON.parse(res.data.jsonStr)
            );

            this.$set(
              this.baseData.componentResultList[parentIndex],
              "BallotListTatol",
              res.data.userNum
            );
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast("网络失败，请稍后重试");
        });
    },
    getchangePercentage(num, parentIndex) {
      //获取百分比
      let percent = "";
      if (num != "0") {
        percent = parseFloat(
          parseFloat(num) /
            this.baseData.componentResultList[parentIndex].BallotListTatol
        );
      } else {
        percent = 0;
      }

      return (percent * 100).toFixed(2);
    },
    jumpBallotListUrl() {
      //跳转列表
      console.log(11111);
    },
    //附件相关方法
    uploadFile(item, index) {
      //点击添加附件
      let _this = this;
      _this.itemMain = item;
      _this.itemMainIndex = index;
      if (_this.clientType == "android") {
        window.android.getInfo(101);
      } else {
        window.webkit.messageHandlers.getImgs.postMessage("1");
      }
    },
    setFiles(data) {
      //App回调添加上传文件
      if (this.itemMain.answerValue != null) {
        this.itemMain.answerValue = this.itemMain.answerValue.split(",");
      } else {
        this.itemMain.answerValue = [];
      }
      let arr = [];
      let componentList = this.baseData.componentResultList;
      let addFlies = componentList[this.itemMainIndex].flies;
      if (this.clientType == "android") {
        arr.push(data.url);
        this.itemMain.answerValue = this.itemMain.answerValue.concat(arr);
        addFlies.push(data.url);
        this.$set(componentList[this.itemMainIndex], "flies", "");
        this.$set(componentList[this.itemMainIndex], "flies", addFlies);
      } else {
        //IOS
        let cc = JSON.parse(data);
        arr.push(cc.url);
        this.itemMain.answerValue = this.itemMain.answerValue.concat(arr);
        this.baseData.componentResultList[this.itemMainIndex].flies.push(
          cc.url
        );
      }
      this.$set(this.baseData, "componentResultList", "");
      this.$set(this.baseData, "componentResultList", componentList);
      this.itemMain.answerValue = this.itemMain.answerValue.join(",");
      this.baseData.componentResultList[this.itemMainIndex].answerValue =
        this.itemMain.answerValue;
    },
    delFile(item, index, itemIndex) {
      //删除附件
      let arr = "";
      let componentList = this.baseData.componentResultList;
      let addFlies = componentList[this.itemMainIndex].flies;
      addFlies.splice(itemIndex, 1);
      this.$set(componentList[this.itemMainIndex], "flies", "");
      this.$set(componentList[this.itemMainIndex], "flies", addFlies);
      arr = componentList[index].answerValue.split(",");
      arr.splice(itemIndex, 1);
      if (arr.length > 0) {
        componentList[index].answerValue = arr.join(",");
      } else {
        componentList[index].answerValue = "";
      }
      this.$set(this.baseData, "componentResultList", "");
      this.$set(this.baseData, "componentResultList", componentList);
    },
    Showswiper(sourcrData, showIndex) {
      //查看预览图片
      let magnifyList = [];
      let _this = this;
      sourcrData.forEach(SelectBigImgs);
      function SelectBigImgs(item) {
        if (
          _this.getFormat(item) == "jpg" ||
          _this.getFormat(item) == "png" ||
          _this.getFormat(item) == "jpeg"
        ) {
          magnifyList.push(item);
        }
      }
      let data = {
        showImgs: magnifyList,
        swipercliclIndex: showIndex,
        swiperShow: true,
      };
      if (magnifyList.length > 0) {
        this.$store.commit("setDataImgs", data);
      }
    },
    //下载附件
    downLoad(data) {
      if (this.clientType == "android") {
        //安卓
        window.android.getInfo(105, String(data));
      } else {
        let dataArguments = {
          url: data,
          twoArguments: "",
        };
        if (
          this.getFormat(data) == "jpg" ||
          this.getFormat(data) == "png" ||
          this.getFormat(data) == "jpeg"
        ) {
          dataArguments.twoArguments = "picture";
        }
        window.webkit.messageHandlers.downLoad.postMessage(
          JSON.stringify(dataArguments)
        );
      }
    },
    checkJoinType() {
      let _this = this;
      if (_this.activityId != "") {
        _this.showViewQuestionPicker = true;
      } else {
        _this.getTopicList();
      }
    },
    showViewQuestion() {
      let _this = this;
      _this.showViewQuestionPicker = false;
      // _this.showBtn = false;
      // _this.editType = true;
      // _this.getTopicList();
    },

    checkBoxChange(data) {
      //保存选中的题目id
      this.answerIndexResult.push(data.id);
    },

    //问卷调查优化
    //1.多选的下拉类型
    checkSelectMoreTypePicker(data, index) {
      this.checkBoxChange(data);
      //点击多选弹框,类型属于下拉
      this.protectionData = "";
      this.protectionResult = [];
      sessionStorage.clear();
      if (this.editType) {
        let guardArr = [],
          Arr1 = [],
          Arr2 = [];

        if (this.baseData.componentResultList[index].answerValue.length > 0) {
          Arr1 = this.baseData.componentResultList[index].answerValue;
          Arr2 = this.baseData.componentResultList[index].selectItemResultsList;
          for (let i = 0; i < Arr2.length; i++) {
            for (let j = 0; j < Arr1.length; j++) {
              if (Arr1[j] == Arr2[i].id) {
                guardArr.push(Arr2[i]);
              }
            }
          }
          sessionStorage.setItem(
            "guardArr",
            JSON.stringify(newApi.cloneDeep(guardArr))
          );
          this.protectionResult =
            this.baseData.componentResultList[index].answerValueName.split(",");
        }

        this.selectMoreTypePicker = true;
        this.selectIndex = index;
        this.protectionData = data.selectItemResultsList;
      }
    },
    //多选下拉类型
    changeSelectTypeValue(childIndex, item) {
      let _this = this;
      //多选下拉类型
      _this.$refs.slectTypeCheckboxes[childIndex].toggle();
      _this.protectionDataItemList.push(item);
      _this.unique(_this.protectionDataItemList);
    },
    //多选展开,投票类型
    changOtherTypeValue(childIndex, parentItem, childItem, parentIndex) {
      let _this = this;
      if (_this.editType) {
        if (_this.double != parentItem.id) {
          _this.protectionOtherList = [];
        }
        if (parentItem.selectType == "check") {
          _this.$refs.changeCheckboxes[childIndex].toggle();
        } else {
          _this.$refs.checkBallotboxes[childIndex].toggle();
        }
        this.$set(childItem, "checkedType", !childItem.checkedType);
        _this.double = parentItem.id;
        this.selectIndex = parentIndex;
        this.checkBoxChange(parentItem);

        _this.protectionOtherList.push(childItem);
        _this.getOtherValue(_this.protectionOtherList);
      }
    },

    changeGuarddata() {
      //多选下拉打开弹框获取之前已经选中的值
      this.protectionDataItemList = [];
      this.protectionDataItemList =
        JSON.parse(sessionStorage.getItem("guardArr")) || [];
    },
    unique(dataArray) {
      //多选下拉类型 数组去重
      let _this = this;
      let removeIndex = [];
      dataArray.forEach((item1, index1) => {
        const exist = dataArray.some(
          (item2, index2) => item1.id === item2.id && index1 !== index2
        );
        if (exist) {
          removeIndex.unshift(index1);
        }
      });
      newApi.each(removeIndex, (index) => {
        delete dataArray[index];
      });
      _this.protectionDataItemList = _this.protectionDataItemList.filter(
        function () {
          return true;
        }
      );
    },
    getOtherValue(dataArray) {
      //其他类型 数组去重
      let _this = this;
      let removeIndex = [];
      dataArray.forEach((item1, index1) => {
        const exist = dataArray.some(
          (item2, index2) => item1.id === item2.id && index1 !== index2
        );
        if (exist) {
          removeIndex.unshift(index1);
        }
      });
      newApi.each(removeIndex, (index) => {
        delete dataArray[index];
      });
      _this.protectionOtherList = _this.protectionOtherList.filter(function () {
        return true;
      });

      let nameArr = [],
        idArr = [];
      _this.protectionOtherList.forEach((item) => {
        idArr.push(item.id);
        nameArr.push(item.title);
      });
      this.$set(
        this.baseData.componentResultList[this.selectIndex],
        "answerValue",
        idArr
      );
      this.$set(
        this.baseData.componentResultList[this.selectIndex],
        "otherTypeValueNames",
        nameArr
      );
    },
    closeDataItemListPicker() {
      //点击取消
      let _this = this;
      this.selectMoreTypePicker = false;
    },
    saveDataItemList() {
      //保存多选的下拉类型值
      let _this = this;
      let dataArr = _this.protectionDataItemList;
      let nameArr = [],
        idArr = [];
      dataArr.forEach((item) => {
        idArr.push(item.id);
        nameArr.push(item.title);
      });
      this.$set(
        this.baseData.componentResultList[this.selectIndex],
        "answerValue",
        idArr
      );
      this.$set(
        this.baseData.componentResultList[this.selectIndex],
        "answerValueName",
        nameArr.join(",")
      );
      this.selectMoreTypePicker = false;
    },

    //单选下拉的方法
    checkShowRadioSeleType(data, parentIndex) {
      let _this = this;

      console.log(data);
      _this.radioSelectData = ""; //先清空值
      _this.radioSelectValueName = data.answerValueName; //单选下拉类型先清空值选中的值
      _this.radioSelectData = data.selectItemResultsList;
      if (_this.editType) {
        _this.selectIndex = parentIndex;
        _this.showRadioSeleType = true;
      }
    },
    CheckRadio(index, data) {
      //选择单选下拉的值
      this.radioSelectValueName = data.title;
      this.radioSelectValue = data;
    },
    closeRadioSeleType() {
      //关闭单选下拉弹框
      if (this.radioSelectValue != "") {
        this.$set(
          this.baseData.componentResultList[this.selectIndex],
          "answerValue",
          this.radioSelectValue.id
        );
        this.$set(
          this.baseData.componentResultList[this.selectIndex],
          "answerValueName",
          this.radioSelectValue.title
        );
      }
      this.showRadioSeleType = false;
    },
    saveRadioSeleType() {
      //确认选择单选值
      this.$set(
        this.baseData.componentResultList[this.selectIndex],
        "answerValue",
        this.radioSelectValue.id
      );
      this.$set(
        this.baseData.componentResultList[this.selectIndex],
        "answerValueName",
        this.radioSelectValue.title
      );
      this.showRadioSeleType = false;
    },
    //单选的check选值
    changeRadioCheckValue(parentIndex, childIndex, data) {
      console.log(data);
      this.RadioCheckValueName = "";
      if (this.editType) {
        this.baseData.componentResultList[
          parentIndex
        ].selectItemResultsList.forEach((item) => {
          item.checkedType = false;
        });
        this.$set(
          this.baseData.componentResultList[parentIndex],
          "answerValueName",
          data.title
        );
        this.$set(
          this.baseData.componentResultList[parentIndex].selectItemResultsList[
            childIndex
          ],
          "checkedType",
          !data.checkedType
        );
        this.$set(
          this.baseData.componentResultList[parentIndex],
          "answerValue",
          data.id
        );
        // data.checkedType = !data.checkedType;

        this.RadioCheckValueName = data.title;
      }
    },
    //点击提交问卷的方法
    saveAwser() {
      // console.log(this.baseData.componentResultList);
      let _this = this;
      let itemList = [];
      let checkArr = [];
      let saveType = true;
      let resultIndex = new Set(this.answerIndexResult);
      this.answerIndexResult = [...resultIndex];

      _this.baseData.componentResultList.forEach((item, index) => {
        let answerData = {
          anwserValue: item.answerValue,
          componentId: item.id,
        };
        if (
          (item.answerValue == null && item.isVerify == true) ||
          (item.answerValue == "" && item.isVerify == true)
        ) {
          _this.$toast("第 " + (index + 1) + " 道题为必填，不能为空！");
          saveType = false;
        }

        itemList.push(answerData);
      });
      if (!saveType) {
        return;
      }
      itemList.forEach((item, index) => {
        console.log(typeof item.anwserValue);
        if (
          item.anwserValue == null ||
          item.anwserValue == "null" ||
          item.anwserValue == "0" ||
          (Array.isArray(item.anwserValue) && !item.anwserValue[0])
        ) {
          return;
        } else {
          checkArr.push(item);
        }
      });
      for (let i = 0; i < checkArr.length; i++) {
        for (let j = 0; j < this.answerIndexResult.length; j++) {
          if (checkArr[i].componentId == this.answerIndexResult[j]) {
            checkArr[i].anwserValue = checkArr[i].anwserValue.join(",");
          }
        }
      }

      console.log("itemList====" + JSON.stringify(itemList));
      let dto = {
        anwserId: _this.anwserId,
        itemList: checkArr,
        status: "finish",
      };

      _this.btnLoading = true;
      _this.$api.activity.player
        .addActivityAnswerItem(dto)
        .then((res) => {
          if (res.code == "1") {
            let text = "提交成功";
            closePage(text);
            _this.itemList = new Array();
            _this.btnLoading = false;
          } else {
            this.$toast(res.msg);
            _this.btnLoading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast("网络失败，请稍后重试");
          _this.btnLoading = false;
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function (newVal) {
        if (newVal && newVal.id) {
          this.setShowLoad(false); //加载状态，默认为true加载
          this.applyData.uid = newVal.id;
          this.initPage();
        }
      },
    },
    deep: true,
  },
};
</script>
<style lang="less">
@import "./css/activityForm.less";
</style>